<template>
  <button @click=next>
    {{ display }}
  </button>
</template>

<script>
const VALUE_TO_CHAR = {
  0: 'T',
  1: 'A',
  2: 'Ж',
  3: '÷'
}

export default {
  data () {
    return { value: 0 }
  },

  methods: {
    next () {
      this.value = (this.value + 1) % 4
      this.$emit('input', this.value)
    }
  },

  computed: {
    display () {
      return VALUE_TO_CHAR[this.value]
    }
  }
}
</script>

<style scoped>
button {
  width: 50px;
  height: 50px;
}
</style>
